import NoResults from "components/Organisms/NoResults"
import PreviewImage from "components/Organisms/PreviewImage"
import React from "react"
import { getName } from "utils/custom.utils"
import { inr } from "utils/formatters.utils"
import { ORDER_TRANSACTION_STATUS, PAYMENT_METHODS } from "data/static.items"
import { Row } from "./InvoiceSummary"
const Transanctions = ({ payments, trackingCode, totalPaid, totalAmount }) => {
  return (
    <>
      {payments?.length > 0 ? (
        <>
          <table className="vt-bulk-update-summary-table">
            <thead className="vt-bulk-update-table-header">
              <tr>
                <th>Reference ID</th>
                <th>Payment Method</th>
                <th>Status</th>
                <th>Amount</th>
                <th className="vt-preview-image-col">Attachment</th>
              </tr>
            </thead>
            <tbody className="vt-bulk-update-table-body">
              {payments?.map((item, idx) => {
                const status = ORDER_TRANSACTION_STATUS?.find(
                  f => f?.id === item?.status
                )
                const method = getName(item?.paymentMethod, PAYMENT_METHODS)
                return (
                  <tr key={idx}>
                    <td>{item?.referenceId}</td>
                    <td>{method}</td>
                    <td>{status?.name}</td>
                    <td>{inr(item.amount)}</td>
                    <td className="d-center">
                      <PreviewImage src={item?.attachment?.url} />
                    </td>
                  </tr>
                )
              })}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={3}></td>
                <td className="font-bold">{inr(totalPaid)}</td>
              </tr>
            </tfoot>
          </table>
          <section className="vt-invoice-summary">
            <Row name="Total Amount" className="mt-2" value={totalAmount} />
            <Row name="Total Paid" className="mt-2" value={totalPaid} />
            <hr className="my-2" />
            <Row
              className="mt-2 vt-total"
              name="Total Outstanding"
              value={inr(totalAmount - totalPaid)}
            />
          </section>
        </>
      ) : (
        <NoResults
          icon="cross"
          title="No order transactions"
          description={`Order ${trackingCode} does not contain any payments`}
        />
      )}
    </>
  )
}

export default Transanctions
